// To fix bugs with auto import
const _window = window
export default _window
